import ReactHtmlParser from 'react-html-parser'
import { sanitizeHtml } from '../../../../helpers/Sanitize'
import { connect, mapStateToProps } from '../../../../helpers/Common'

const Message = ({ redux, val }) => {
  return (
    <div className={`alert ${redux.darkModeOn ? 'alert-dark' : 'alert-light'} my-2`}>
      {val ? ReactHtmlParser(sanitizeHtml(val)) : ''}
    </div>
  )
}

export default connect(mapStateToProps)(Message)
